export default [
    { RoleClass: "Manager", Role: "Manager", IsLogin: true },
    { RoleClass: "Staff", Role: "Staff", IsLogin: true },
    { RoleClass: "Users", Role: "Users", IsLogin: true },
    { RoleClass: "Company", Role: "Staff", IsLogin: false, RoleClassField: "Company" },
    { RoleClass: "Company", Role: "Users", IsLogin: false, RoleClassField: "Company" }
]